import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import bgSrc from '../../../assets/images/start/bg.webp';
import styles from './GlowCard.css';

const cx = classnames.bind(styles);

function GlowCard({ className, children }) {
    return (
        <div
            className={cx('root', { [className]: Boolean(className) })}
            style={{ '--bg-src': `url(${bgSrc})` }}
        >
            {children}
        </div>
    );
}

GlowCard.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};

GlowCard.defaultProps = {
    className: ''
};

export {
    GlowCard
};
